"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const Services_1 = __importDefault(require("../../Services"));
class Pagination {
    constructor(pagination) {
        this.$pagination = pagination;
        this.$links = lodash_1.default.get(this.$pagination, 'links');
        this.$meta_links = lodash_1.default.get(this.$pagination, 'meta.links', undefined);
    }
    static getPageNumberWithUrl(url) {
        return Services_1.default.parseQueryString(Services_1.default.getQueryString(url));
    }
    static isActive(item) {
        let isActive;
        if (lodash_1.default.isBoolean(isActive = lodash_1.default.get(item, 'active')) && isActive === true) {
            return ' active-page';
        }
        return '';
    }
    render() {
        if (lodash_1.default.has(this.$pagination, 'meta.has_pages') && !lodash_1.default.get(this.$pagination, 'meta.has_pages')) {
            return '';
        }
        const last_section = `${this.next()}${this.last()}`;
        return `<div class="row">
                    <div class="col-12">
                        <div class="pagination-cm">
                            ${this.first()}
                            ${this.prev()}
                            ${this.pageItems()}
                            ${last_section}
                        </div>
                    </div>
                </div>`;
    }
    pageItems() {
        if (!lodash_1.default.isArray(this.$meta_links)) {
            throw new Error('not exists pagination links');
        }
        let items = '';
        let page;
        this.$meta_links.forEach(item => {
            const url = lodash_1.default.isNull(item === null || item === void 0 ? void 0 : item.url) ? 'javascript:;' : item === null || item === void 0 ? void 0 : item.url;
            page = !isNaN(page = lodash_1.default.toNumber(lodash_1.default.get(item, 'label'))) ? page : '#';
            items = items.concat(`<a class="pagination-item${Pagination.isActive(item)}${lodash_1.default.isNumber(page) ? '' : ' disabled'}" data-page="${page}" href="${url}">${(item === null || item === void 0 ? void 0 : item.label) || '...'}</a>`);
        });
        return items;
    }
    prev() {
        if (!lodash_1.default.isArray(this.$meta_links)) {
            throw new Error('not exists pagination links');
        }
        const prev = lodash_1.default.head(this.$meta_links);
        this.$meta_links = lodash_1.default.pull(this.$meta_links, prev);
        if (!lodash_1.default.isUndefined(prev) && !lodash_1.default.isNull(prev === null || prev === void 0 ? void 0 : prev.url)) {
            const page = lodash_1.default.get(Pagination.getPageNumberWithUrl(prev === null || prev === void 0 ? void 0 : prev.url), 'page');
            return `<a data-toggle="tooltip" data-theme="dark" data-page="${page}" data-placement="bottom" title="${lodash_1.default.get(prev, 'label', 'قبلی')}" href="${lodash_1.default.get(prev, 'url', 'javascript:;')}" class="pagination-item first">
                        <i class="fas fa-angle-right"></i>
                    </a>`;
        }
        return `<a data-toggle="tooltip" data-theme="dark" data-placement="bottom" title="${lodash_1.default.get(prev, 'label', 'قبلی')}" href="javascript:;" class="pagination-item disabled first">
                    <i class="fas fa-angle-right"></i>
                </a>`;
    }
    next() {
        if (!lodash_1.default.isArray(this.$meta_links)) {
            throw new Error('not exists pagination links');
        }
        const next = lodash_1.default.last(this.$meta_links);
        this.$meta_links = lodash_1.default.pull(this.$meta_links, next);
        if (!lodash_1.default.isUndefined(next) && !lodash_1.default.isNull(next === null || next === void 0 ? void 0 : next.url)) {
            const page = lodash_1.default.get(Pagination.getPageNumberWithUrl(next === null || next === void 0 ? void 0 : next.url), 'page');
            return `<a data-toggle="tooltip" data-theme="dark" data-page="${page}" data-placement="bottom" title="${lodash_1.default.get(next, 'label', 'بعدی')}" href="${lodash_1.default.get(next, 'url', 'javascript:;')}" class="pagination-item next">
                        <i class="fas fa-angle-left"></i>
                    </a>`;
        }
        return `<a data-toggle="tooltip" data-theme="dark" data-placement="bottom" title="${lodash_1.default.get(next, 'label', 'بعدی')}" href="javascript:;" class="pagination-item disabled next">
                    <i class="fas fa-angle-left"></i>
                </a>`;
    }
    first() {
        let first = lodash_1.default.get(this.$links, 'first'), isFirstCurrentPage;
        const current_page = lodash_1.default.toNumber(lodash_1.default.get(this.$pagination, 'meta.current_page'));
        if ((isFirstCurrentPage = lodash_1.default.isNumber(current_page) && current_page === 1)) {
            first = 'javascript:;';
        }
        if (lodash_1.default.isUndefined(first) || lodash_1.default.isNull(first)) {
            return `<a data-toggle="tooltip" data-theme="dark"
                        data-placement="bottom" title="اولین" href="javascript:;" class="pagination-item first disabled">
                        <i class="fas fa-angles-right"></i>
                    </a>`;
        }
        return `<a data-toggle="tooltip" data-theme="dark"
                        data-placement="bottom" title="اولین" data-page="${1}" href="${first}" class="pagination-item first ${isFirstCurrentPage && 'disabled'}">
                        <i class="fas fa-angles-right"></i>
                    </a>`;
    }
    last() {
        let last = lodash_1.default.get(this.$links, 'last'), isLastPageCurrent;
        const current_page = lodash_1.default.toNumber(lodash_1.default.get(this.$pagination, 'meta.current_page'));
        const last_page = lodash_1.default.toNumber(lodash_1.default.get(this.$pagination, 'meta.last_page'));
        if ((isLastPageCurrent = (lodash_1.default.isNumber(current_page) && current_page === last_page))) {
            last = 'javascript:;';
        }
        if (lodash_1.default.isUndefined(last) || lodash_1.default.isNull(last)) {
            return `<a data-toggle="tooltip" data-theme="dark"
                        data-placement="bottom" title="آخرین" href="javascript:;" class="pagination-item last disabled">
                        <i class="fas fa-angles-left"></i>
                    </a>`;
        }
        return `<a data-toggle="tooltip" data-theme="dark"
                        data-placement="bottom" title="آخرین" data-page="${last_page}" href="${last}" class="pagination-item last ${isLastPageCurrent && 'disabled'}">
                        <i class="fas fa-angles-left"></i>
                    </a>`;
    }
}
exports.default = Pagination;
